module.exports = __webpack_public_path__ + "img/step2.8343322a.png";